// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';

function isBenignSafariMediaError(event) {
  const message = event.exception?.values?.[0]?.value || event.message || '';
  return (
    message.includes('InvalidStateError') &&
    message.includes('invalid state')
  );
}

Sentry.init({
  dsn: "https://dfcea38c7023d34ae54c8e2821680233@o4510642114461696.ingest.de.sentry.io/4510642216108112",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  enableLogs: true,
  beforeSend(event) {
    if (isBenignSafariMediaError(event)) {
      return null;
    }
    return event;
  },
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
